// FICHIER : frontend/src/components/Logo.jsx
export default function Logo({ height = 48 }) {
  return (
    <img
      src="/logo-tos.png"
      alt="TOS Solutions"
      style={{ height, width: 'auto', display: 'block' }}
    />
  );
}
